import { AxiosInstance } from "axios";
import { CrudService } from "./crudService";
import { IDelegateRoleGroup } from "../interfaces/IDelegateRoleGroup";

export class DelegateRoleGroupService extends CrudService<IDelegateRoleGroup> {

    constructor(apiClient: AxiosInstance) {
        super(apiClient, '/admin/delegate-role-group');
    }
}